/*=========================================================================================
	File Name: moduleAuthActions.js
	Description: Auth Module Actions
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import userJson from "../../../public/user.json";
import axios from "axios";
import router from '../../router'
import state from "../state"
import store from "../store";

export default {
	//storehouse set-up
	listStorehouseForRole({ getters, commit, dispatch }, item) {
		const token = localStorage.getItem("fullFilmentTokenId")
		if (token === null || token == "null") { }
		else
			return new Promise((resolve, reject) => {
				if (userJson.type == "fullfilment") {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						dispatch("listStorehouseAllValues2").then(response => {
							resolve(response);
						})
					}
					else if (state.AppActiveUser.ROLE == "Company") dispatch("listStorehouseForCompany", state.AppActiveUser.companyid).then(response => {
						resolve(response);
					})
				} else if (userJson.type == "dropshipping") {
					if (state.AppActiveUser.ROLE == "Owner" || state.AppActiveUser.ROLE == "Admin") {
						dispatch("listStorehouseAllValues2Ds").then(response => {
							resolve(response);
						})
					}
					else if (state.AppActiveUser.ROLE == "Company") dispatch("listStorehouseAllValues2Ds", state.AppActiveUser.companyid).then(response => {
						resolve(response);
					})
				}


			})
	},
	updateStorehouseDs({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item.depotId)
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	updateStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Depot/update/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item.depotId)
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	addStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Depot/add/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	addStorehouseDs({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/depot", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					commit("ADD_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/depot", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseAllValues({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/depot/all", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseAllValues2Ds({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/depot/all2", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {

					item = JSON.parse(response.data.json);

					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOREHOUSE_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseAllValues2({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/depot/all2", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {

					item = JSON.parse(response.data.json);

					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOREHOUSE_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseForCompany({ commit }, item) {
		if (item == "company") item = state.AppActiveUser.companyid
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/depot/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_COMPANY_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					commit("STOREHOUSE_COMPANY_LIST", []);

					router.push("/login")
				}
			}).catch(err => {
				commit("STOREHOUSE_COMPANY_LIST", []);

				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("STOREHOUSE_COMPANY_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	deleteStorehouseDs({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/depot/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	deleteStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Depot/delete/depot/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					commit("DELETE_ITEM_STOREHOUSE", item)
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	storehouseTypes({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/depottype", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = response.data;
					commit("STOREHOUSE_TYPE_LIST", item);
					resolve(response);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				console.log(err)
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	//storehouse detail set-up
	addStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Stock/add/storehouse", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/storehouselist", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSE_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listStorehouseDetailForStorehouse({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/storehouselist/depots/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("STOREHOUSEDETAIL_LIST_FOR_STOREHOUSE", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	updateStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/uzumservice/Stock/update/storehouse", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	deleteStorehouseDetail({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Stock/delete/storehouse/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	//shade depot set-up
	addDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/uzumservice/Depot/add/depotallow", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/depotallow/company/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("DEPOTALLOW_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("DEPOTALLOW_LIST", []);
				}
				resolve(err.response);
			});
		});
	},
	deleteDepotAllow({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/uzumservice/Depot/delete/depotallw/" + item.DepotCompanyId + "/" + item.DepotId + "?companyid=" + item.DepotCompanyId, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listUsingDepot({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Depot/list/usingdepot", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("USINGDEPOT_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	//Shelf transaction set-up
	listStockForBarcode({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/uzumservice/Stock/list/stockbarcode/barcode/" + item.companyId + "?barcode=" + item.barcode, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					console.log(response)
					let itemL = {};
					if (response.data.message == "Stock list in company by master barcode") {
						let items = JSON.parse(response.data.json)
						itemL = { value: items[0], item: item };
					} else {
						itemL = { value: JSON.parse(response.data.json), item: item };
					}
					commit("ADD_STOCK_ON_SHELF", itemL);

					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
				}
				resolve(err.response);
			});
		});
	},
	listShelfTransCorridorCheck({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/corridor/code?corridorCode=" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("SHELF_TRANS_CORRIDOR_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listShelfTransShelfCheck({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/shelf/code?shelfCode=" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("SHELF_TRANS_CORRIDOR_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listShelfTrans({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/shelftrans", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("SHELF_TRANS_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listShelfTransForShelf({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/shelftrans/shelf/code?shelfCode=" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					//	commit("SHELF_TRANS_PRODUCT_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	addShelfTrans({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/Corridor/add/shelftrans", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {

					resolve(response);
				})
				.catch(err => {
					console.log(err)
					if (err.response.status == 401) {
						router.push("/login")
					}
					console.log(err.response)
					resolve(err.response);
				});
		});
	},
	// shelf set-up
	addShelf({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/Corridor/add/shelf", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listShelf({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/shlef", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("SHELF_ALL_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listShelfForCorridor({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/shelf/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("SHELF_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	updateShelf({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/Corridor/update/shelf", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	deleteShelf({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }

		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/Corridor/delete/shelf/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	//Corridor set-up
	addCorridor({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/Corridor/add/corridor", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					consol.elog(err)
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	listCorridor({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/Corridor/list/corridor", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CORRIDOR_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				console.log(err)
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	updateCorridor({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/Corridor/update/corridos", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	deleteCorridor({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }

		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/Corridor/delete/corridor?id=" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	//Cargo set-up
	addCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.post(sistemAddress + "api/ProductTracking/add/cargodefination", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					if (err.response.status == 401) {
						router.push("/login")
					}
					resolve(err.response);
				});
		});
	},
	deleteCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.delete(sistemAddress + "api/ProductTracking/delete/cargodefination/" + item, {
					headers: {
						Authorization: `Bearer ${token}`
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
	listCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/list/cargodefination", {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CARGO_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				}
				resolve(err.response);
			});;
		});
	},
	listCargoForDepot({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios.get(sistemAddress + "api/ProductTracking/list/cargodefination/depotid/" + item, {
				headers: {
					Authorization: `Bearer ${token}`,
					token: token
				}
			}).then(response => {
				if (response.status == 200) {
					item = JSON.parse(response.data.json);
					commit("CARGO_LIST", item);
					resolve(response.data);
				} else if (response.status == 401) {
					router.push("/login")
				} else if (response.status == 400) {

					commit("CARGO_LIST", []);
				}
			}).catch(err => {
				if (err.response.status == 401) {
					router.push("/login")
				} else if (err.response.status == 400) {
					commit("CARGO_LIST", []);
				}
				resolve(err.response);
			});;
		});
	},
	updateCargo({ commit }, item) {
		var sistemAddress = userJson.userService;
		const token = localStorage.getItem("fullFilmentTokenId")
		if (!token) { store.dispatch("auth/logout"); router.push("/login"); }
		return new Promise((resolve, reject) => {
			axios
				.put(sistemAddress + "api/ProductTracking/update/cargodefination", item, {
					headers: {
						Authorization: `Bearer ${token}`,
						token: token
					}
				})
				.then(response => {
					resolve(response);
				})
				.catch(err => {
					resolve(err.response);
				});
		});
	},
}
